import React from 'react';
import PreviewVideo from 'components/PreviewVideo/PreviewVideo';
import classes from './CallPreview.module.scss';
import VideoButton from 'components/CallControls/VideoButton';
import AudioButton from 'components/CallControls/AudioButton/AudioButton';

const CallPreview = () => (
  <div className={classes.container}>
    <PreviewVideo />
    <div className={classes.buttonBar}>
      <VideoButton isPreCall={true} useLiteButton={true} useLightTheme={true} />
      <AudioButton useLiteButton={true} useLightTheme={true} />
    </div>
  </div>
);

export default CallPreview;
